import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

import { ReactComponent as RecycleIcon } from '../../../assets/category/recycle.svg';

export const NodeContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 12px;
  display: flex;
  flex-direction: column;
`;

export const Component = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
`;

export const ComponentName = styled.div`
  width: 60%;
  font-weight: bolder;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ComponentRecycleRate = styled.div`
  color: ${COLOR.MID_GREY};
`;

export const Recycle = styled(RecycleIcon)`
  height: 12px;

  path {
    fill: ${COLOR.BATTERY_TECH_REVIEW};
  }
`;

export const Origin = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 10px;
`;
